import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/sections/Hero";
import Opportunity from "../components/sections/Opportunity";
import Problem from "../components/sections/Problem";
import Solution from "../components/sections/Solution";
import Pipeline from "../components/sections/Pipeline";
import InvestmentFilter from "../components/sections/InvestmentFilter";
import Pistachio from "../components/sections/Pistachio";
import Tech from "../components/sections/Tech";
import Model from "../components/sections/Model";
import InvestorInfo from "../components/sections/InvestorInfo";
import Sustainability from "../components/sections/Sustainability";
import Governance from "../components/sections/Governance";
import Team from "../components/sections/Team";
import Lanzadera from "../components/sections/Lanzadera";
import Docs from "../components/sections/Docs";
import Contact from "../components/sections/Contact";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <main data-testid="home-page" className="relative">
      <Hero />
      <Opportunity />
      <Problem />
      <Solution />
      <Pipeline />
      <InvestmentFilter />
      <Pistachio />
      <Tech />
      <Model />
      <InvestorInfo />
      <Sustainability />
      <Governance />
      <Team />
      <Lanzadera />
      <Docs />
      <Contact />
    </main>
  );
}
